import { ComboBoxModel } from "@genexus/chameleon-controls-library";
import { GxOption } from "../../common/types";

export const mapStylesToComboBoxItemModel = (
  styles: GxOption[]
): ComboBoxModel =>
  styles?.map(style => ({
    value: style.id,
    caption: style.label || style.name
  }));
